import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

const Notification = ({
  message,
  duration = 30000,
  backgroundColor = "#00A651",
  soundSrc = "/notification.mp3",
}) => {
  const [visible, setVisible] = useState(true);
  const [progress, setProgress] = useState(100);
  const history = useHistory();
  const progressIntervalRef = useRef(null);

  const getRedirectPath = (message) => {
    console.log("messageeeee", message);
    if (message.toLowerCase().includes("payment")) return "/payments";
    if (message.toLowerCase().includes("activetable")) return "/dine-in";
    if (message.toLowerCase().includes("pickup")) return "/pickup-orders";
    if (message.toLowerCase().includes("booking")) return "/bookings";
    return "/"; // Default path
  };

  useEffect(() => {
    const playSound = () => {
      const audio = new Audio(soundSrc);
      audio.play().catch((error) => console.error("Audio play failed:", error));
    };

    playSound();

    const startTime = Date.now();
    progressIntervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 100 - (elapsed / duration) * 100);
      setProgress(remaining);

      if (remaining <= 0) {
        clearInterval(progressIntervalRef.current);
      }
    }, 100);

    const timer = setTimeout(() => {
      if (visible) {
        history.push(getRedirectPath(message));
      }
    }, duration);

    return () => {
      clearTimeout(timer);
      clearInterval(progressIntervalRef.current);
    };
  }, [history, visible, message, duration, soundSrc]);

  const handleClose = (e) => {
    e.stopPropagation();
    setVisible(false);
  };

  const handleNotificationClick = () => {
    setVisible(false); // Close the notification
    history.push(getRedirectPath(message)); // Navigate to the respective page
  };

  if (!visible) return null;

  // ✅ Notification styling
  const notificationStyle = {
    position: "fixed",
    top: "20px",
    right: "20px",
    backgroundColor: backgroundColor,
    color: "white",
    padding: "16px",
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    gap: "15px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    maxWidth: "380px",
    width: "calc(100% - 40px)",
    animation: "slideIn 0.5s forwards",
    transform: "translateZ(0)",
  };

  const iconStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    borderRadius: "50%",
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  };

  const contentStyle = {
    flex: 1,
  };

  const messageStyle = {
    margin: 0,
    fontWeight: 500,
    fontSize: "15px",
  };

  const hintStyle = {
    fontSize: "12px",
    marginTop: "4px",
    opacity: 0.8,
    display: "flex",
    alignItems: "center",
  };

  const closeButtonStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    border: "none",
    color: "white",
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.2s ease",
    padding: 0,
    marginLeft: "8px",
    flexShrink: 0,
  };

  const progressContainerStyle = {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "4px",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    overflow: "hidden",
  };

  const progressBarStyle = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    transition: "width 0.1s linear",
  };

  return (
    <div style={notificationStyle} onClick={handleNotificationClick}>
      <div style={iconStyle}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M18 8C18 6.4 17.3 4.9 16.2 3.8C15.1 2.6 13.6 2 12 2C10.4 2 8.9 2.6 7.8 3.8C6.6 4.9 6 6.4 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="white" strokeWidth="2" />
          <path d="M13.7 21C13.6 21.3 13.3 21.6 13 21.7C12.7 21.9 12.3 22 12 22C11.7 22 11.3 21.9 11 21.7C10.7 21.6 10.4 21.3 10.3 21" stroke="white" strokeWidth="2" />
        </svg>
      </div>
      <div style={contentStyle}>
        <p style={messageStyle}>{message}</p>
        <div style={hintStyle}>
          Click to view
          <svg style={{ marginLeft: "4px" }} width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" />
          </svg>
        </div>
      </div>

      <button style={closeButtonStyle} onClick={handleClose} aria-label="Close notification">
        ✕
      </button>

      <div style={progressContainerStyle}>
        <div style={progressBarStyle}></div>
      </div>

      <style>
        {`
          @keyframes slideIn {
            0% { transform: translateX(100%); opacity: 0; }
            100% { transform: translateX(0); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default Notification;